import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "monthlyMeetingSection",
    "otherSection",
  ]

  connect() {
    this.update()
  }

  update() {
    const checked = [...this.element.querySelectorAll('[name="training_attendance_form[training_type][]"]:checked')]
      .map(el => el.value)

    this.#showTargets("monthlyMeetingSection", checked.includes("monthly_safety_meeting"))
    this.#showTargets("otherSection", checked.includes("other"))
  }

  #showTargets(targetName, visible) {
    const key = `${targetName}Targets`
    for (const el of this[key]) {
      if (visible) {
        el.classList.remove("hidden", "opacity-0", "translate-y-2")
      } else {
        el.classList.add("hidden", "opacity-0", "translate-y-2")
      }
    }
  }
}
